export default "__VITE_ASSET__CXn8nnla__"